import React, { Component } from 'react';
import { translate } from '../../../../services';
import { EmptySearchStateIcon, EmptyStateIconNew, filterIcon } from '../../../../../style/images';
import { PropTypes } from 'prop-types';
import { Box, Grid, SvgIcon } from '@mui/material';
import { SvgImage } from '../../../../components';

export class NoResultsFound extends Component {
  render() {
    const { show, isSearchPage, isCartPage, image } = this.props;
    // return !show ? null
    //   : !isSearchPage ?
    //     <div className="no-results-found">
    //       <h1>{ translate( 'Select all filters' ) }</h1>
    //       <span>{ translate( 'No results found, please refine your selection' ) }</span>
    //     </div>
    //     :
    //     <div className="no-results-found">
    //       <span>{ translate( 'No results found' ) }</span>
    //       <span>{ translate( 'Try checking your spelling or use more general terms' ) }</span>
    //     </div>
    // return !show? null
    //     : !isSearchPage?
    //     <Grid item xl={12}>
    //       <h1>{ translate( 'Select all filters' ) }</h1>
    //       <span>{ translate( 'No results found, please refine your selection' ) }</span>
    //     </Grid>
    //     :
    //     <Grid item xl={12}>
    //       <span>{ translate( 'No results found' ) }</span>
    //       <span>{ translate( 'Try checking your spelling or use more general terms' ) }</span>
    //     </Grid>
    return !show?null
            : !isSearchPage && !isCartPage && !this.props.isProductPage?
        <Grid className="select-filter" item xl={12}>
          <h1>{ translate( 'Select all filters' ) }</h1>
          <span>{ `${translate( 'No results found')}, ${translate("please refine your selection")}` }</span>
        </Grid>:
        <Box width='100%' height={{md:"100%", xs:"100%"}} sx={{display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"column", gap:"24px", background: "#F5F5F5"}}>
          <Box className='no-result-found-img' component="img" src={EmptySearchStateIcon} width={{md:"80px", xs:"60px"}} height={{md:"80px", xs:"60px"}} sx={{mt:{md:this.props.isProductPage?"10%":"0px", xs:"0px"}}}></Box>
          <Box height={{md:"47px", xs:"41px"}} width="318px" sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"8px"}}>
            <Box width="max-content" height="22px" padding="0px 10px" sx={{display:"flex", justifyContent:"center", alignItems:"center", gap:"10px"}}>
              <span className='no-result-found-text'>{translate(!isSearchPage?"No items found.":"No results found")}</span>
            </Box>
            <Box width="100%" height={isSearchPage?"17px":"34px"} padding="0px 10px" sx={{display:"flex", justifyContent:"center", alignItems:"center", gap:"10px"}}>
              {this.props.isProductPage ?<span className='no-items-found-info'>{`${translate("There are no products available for")} ${this.props.currentSelector.selector.name} `}</span>:isSearchPage?
              <span className="search-retry">{translate("Please try typing again")}</span>:
              <span className='no-items-found-info'>{translate("There is no available items. Once you add products to the cart they will appear here.")} </span>}
            </Box>
          </Box>
        </Box>
  }
}


NoResultsFound.propTypes = {
  show: PropTypes.bool
};

NoResultsFound.defaultProps = {
  isSearchPage: false
};